import { getS3URL } from "@/utils/helpers";

export function getValidProfileURL(url: string) {
  console.log('getValidProfileURL', url);
  if (url.startsWith('http')) {
    console.log('url is valid', url);
    return url;
  } else if (url.startsWith('"')) {
    console.log('Handling edge case of url being wrapped in quotes');
    const validUrl = url.substring(1, url.length - 1).replace(/\\\//g, '\/');
    console.log('validUrl', validUrl);
    return validUrl;
  }
  console.log('url is not valid', url);
  return getS3URL(url) || "https://placehold.co/100x100";
}
